export default __webpack_public_path__ + "static/media/plain-sticker-I.54c08592.png";